export const LAYOUT_STYLES = {
    buttonContainer: { display: "flex", justifyContent: "flex-end", gap: "10px", mt: "20px" }
};